import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { WarningAmber, Info, ErrorOutline, Close } from "@mui/icons-material";

function ReusableDialog({
  open,
  onClose,
  title,
  message,
  type = "error", // "info" | "warning" | "error"
}) {
  const getIcon = () => {
    switch (type) {
      case "warning":
        return <WarningAmber color="warning" fontSize="large" />;
      case "error":
        return <ErrorOutline color="error" fontSize="large" />;
      default:
        return <Info color="primary" fontSize="large" />;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, p: 1.5 },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          {getIcon()}
          <Typography variant="h6" fontWeight="bold">
            {title || "Alert"}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pb: 1 }}>
        <Typography variant="body1" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2, px: 3 }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReusableDialog;
